import { triggerUserEvent } from "services/eventFunctions";
import { MembershipI } from "types/MembershipsI";
import { UserI } from "types/UserI";

const UserReducer = (state: any, action: { payload: any; type: any; }) => {
    // console.log('user reducer');
    
    const { payload, type } = action

    switch (type) {
        case ('update_user') : {
            
            let user = payload as UserI
            // console.log("User Reducer".toUpperCase());
            // console.log('update user'.toUpperCase());
            
            // console.log(user);
            if (!user || typeof(user) == 'string') {
                return state 
            }
            
            sessionStorage.setItem('xf_active_user', JSON.stringify(user));


            return {
                client_id: user.client_id,
                connection_id: user.connection_id,
                credits: user.credits,
                first_name: user.first_name,
                second_name: user.second_name,
                phone: user.phone,
                email: user.email,
                address: user.address,
                birth_date: user.birth_date
            }
        }
        case ('update_user_account'): {

            return {
                ...state,
                birth_date: payload.DAT_NAR,
                address: [payload.ADRESA_1, payload.ADRESA_2, payload.ADRESA_3, payload.ADRESA_4],
                email: payload.EMAIL_II,
                phone: payload.TEL_MOB
            }
        }
        case ('get_user'): {
            let user = payload as UserI
            if (!user || typeof(user) == 'string') {
                return state 
            }
            sessionStorage.setItem('xf_active_user', JSON.stringify(user));

            return {
                ...state,
                client_id: user.client_id,
                connection_id: user.connection_id,
                credits: user.credits,
                first_name: user.first_name,
                second_name: user.second_name,
                phone: user.phone,
                email: user.email,
                address: user.address,
                birth_date: user.birth_date,
            }
        }
        case ('log_in'): {
            
            let user = payload as UserI
            if (!user || typeof(user) == 'string') {
                return state 
            }
            // console.log(user);
            sessionStorage.setItem('xf_active_user', JSON.stringify(user));
            triggerUserEvent()

            if (user) {
                return {
                    ...state,
                    client_id: user.client_id,
                    connection_id: user.connection_id,
                    credits: user.credits,
                    first_name: user.first_name,
                    second_name: user.second_name,
                    phone: user.phone,
                    email: user.email,
                    address: user.address,
                    birth_date: user.birth_date
                }
            }

            return {
                ...state, 
            }
        }
        case ('log_out'): {
            // console.log('dispatch log out');
            // console.log(payload);
            sessionStorage.removeItem('xf_active_user');
            triggerUserEvent()

            return {
                client_id: null,
                connection_id: null,
                credits: null,
                first_name: null,
                second_name: null,
                phone: null,
                email: null,
                membership: null,
                address: [],
                birth_date: null
            }
        }
        case ('update_client_id') : {
            let client_id = payload.client_id
            return {
                ...state,
                client_id: client_id
            }
        }
        case ('update_user_email'): {
            
            let email = payload.email
            // console.log('update_user_email');
            // console.log(email);
            
            return {
                ...state,
                email: email
            }
        }
        case ('update_user_credits'): {
    
            let user = payload as UserI
            
            if (!user || typeof(user) == 'string') {
                return state 
            }
            
            if (!('credits' in user)){
                return state
            }

            sessionStorage.setItem('xf_active_user', JSON.stringify(user));


            return {
                ...state, 
                credits: user.credits,
            }
        }
        default:
            return state
    }
}

export default UserReducer